import React from 'react';

import LazyImage from 'gui/components/LazyImage/LazyImage';
import HowItWorksPoints from '../../../guarantees/components/howItWorksPoints/HowItWorksPoints';

interface IBuyerPointsProps {
  className?: string;
}

const BuyerPoints = (props: IBuyerPointsProps) => (
  <HowItWorksPoints
    pointIcon={<LazyImage src={'/img/guranteeOk.png'} title={'point'}/>}
    points={[
      'שלחו בקשה לרכישה',
      'קבלו עדכון ברגע שהמוכר אישר את העסקה',
    //  'העבירו את התשלום ל deal&go - התשלום יועבר למוכר רק לאחר השלמת העסקה',
      'קבלו את השוברים / הכרטיסים וודאו שהכל תקין',
      'לאחר 10 ימים התשלום יועבר למוכר',
    ]}
    {...props}
  />
);

BuyerPoints.defaultProps = {
  className: undefined,
};

export default React.memo(BuyerPoints);
